module.exports = __webpack_public_path__ + "img/wallet-hover.db15d62d.svg";